import Select from 'react-select';
import {connect} from 'react-redux';

import { Component } from 'react';
import {actions} from 'forms/rrf';

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value
    };
  }

  componentDidMount() {
    const {model, dispatch, value} = this.props;

    // Match handleChange / the render `selected` resolution: `value` may be an option object
    // ({value, label}) or a raw primitive (e.g. invalidate-scans passes '' for "All"). Reading
    // `.value` off a primitive is undefined, which would seed the form model with undefined
    // instead of the intended sentinel ('') and leak into submit payloads (Copilot review, #4341).
    const initialValue = value && typeof value === 'object' ? value.value : (value || '');
    dispatch(actions.change(model, initialValue));
    this.setState({value});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
  }

  handleChange(val) {
    const {model, dispatch} = this.props;
    this.setState({value: val}, () => {
      if (val === null) {
        dispatch(actions.change(model, ''));
      } else {
        dispatch(actions.change(model, val.value));
      }

      if (typeof this.props.onChange === 'function') {
        this.props.onChange(val);
      }
    });
  }

  render() {
    const {data, placeholder} = this.props;
    const searchable = this.props.searchable || false;
    const {value} = this.state;
    // react-select v5 needs the matching option object, not a raw value. Callers such as the
    // invalidate-scans staff select pass a raw string (e.g. '' for "All"), which v5 cannot match
    // — so resolve it to the option here, otherwise the control renders blank.
    const selected = value && typeof value === 'object'
      ? value
      : data.find(option => String(option.value) === String(value)) || null;
    return (
      <Select
        className={this.props.className || ''}
        classNamePrefix="rs"
        // No clear (x): the only consumer (invalidate-scans staff select) defaults to "All"
        // (value ''), so clearing is meaningless. react-select v1 (pre-upgrade) showed the x by
        // default AND crashed on clear (its onChange reads event.value with no null guard).
        isClearable={false}
        onChange={option => this.handleChange(option)}
        options={data}
        placeholder={placeholder}
        isSearchable={searchable}
        value={selected}
      />
    );
  }
}

export default connect()(DropDown);
